import _extends from "@swc/helpers/src/_extends.mjs";
import React, { useContext } from 'react';
import { getComponentName } from './helpers';
export const MobileContext = /*#__PURE__*/ React.createContext(false);
MobileContext.displayName = 'MobileContext';
// HOC for convenience...
export function withMobileContext(Component) {
    const DecoratedComponent = (props)=>{
        const isMobile = useContext(MobileContext);
        return /*#__PURE__*/ React.createElement(Component, _extends({
            isMobile: isMobile
        }, props));
    };
    DecoratedComponent.displayName = `withMobileContext(${getComponentName(Component)})`;
    return DecoratedComponent;
}
